import $ from 'jquery';

import { i18n } from '../../translation.js';
import FileUploadMultiple from '../file-upload-multiple/file-upload-multiple.js';
import template from './education-signup.vhtml';
import countries from './countries'; // https://restcountries.eu/rest/v2/all?fields=name;alpha2Code
 
import { trackFormSubmit } from '../../scripts/tag-manager';
import { generateFictionalCPR } from '../../scripts/generateFictionalCPR';

export default {
	validate: null,
	template,
	components: {
		FileUploadMultiple,
	},
	props: {
		qdPopup: {
			type: Object,
			default: null,
		},
		termsConditions: {
			type: String,
			default: '',
		},
        locale: {
            type: String,
            default: '',
        }
	},
	computed: {
		isFormValid() {
			return Object.keys( this.fields ).reduce( ( valid, key ) => this.fields[key].valid && valid, true );
		},
		headline() {
			switch ( this.submitStatus ) {
			case 'success':
				return i18n.t( 'youSignupForSuccess' );
			case 'error': 
				return i18n.t( 'youSignupForError' );
			default:
				return i18n.t( 'youSignupFor' );
			}
		},
		submitMessage() {
			switch ( this.submitStatus ) {
			case 'success':
				return i18n.t( 'confirmationEducationBooked' );
			case 'error': 
				return '';
			default:
				return '';
			}
		},
		BestaetKandidatUdd() {
			return oneOf( this.educationalBackground, [ 'D', 'A' ]) ? 'J' : 'N';
		},
		showOtherHigherEducationField() {
			return oneOf( this.educationalBackground, 'DD' );
		},
		showWorkExperienceField() {
			return oneOf( this.educationalBackground, [ 'D', 'A' ]);
		},
		showHighschoolDetailsFields() {
			return oneOf( this.educationalBackground, 'G' );
		},
		showLocationChoices() {
			return this.numberOfLocationChoices > 0;
		},
		showLocationChoiceDisabledDisclaimer() {
			return this.numberOfLocationChoices === 1;
		},
		numberOfLocationChoices() {
			return this.locationChoices.length;
		},
		EksamensType() {
			if ( this.AdgangsGrundlag !== 'G' ) {
				return '';
			}
			return this.eksamenstypeField.length > 0 ? this.eksamenstypeField[ 0 ] : '';
		},
		CprNr() {
			// Generate a CPR number according to SIS rules, if user has none
			if ( this.CPR === 'P' ) {
				return this.cprField;
			} else {
				const firstName = this.ForNavn;
				const lastName = this.EfterNavn;
				const birthDate = this.DateOfBirth;
				const gender = this.gender;
		
				return generateFictionalCPR({ firstName, lastName, birthDate, gender });
			}
		},
		AdgangsGrundlag() {
			// Minor hack to allow samae value multiple times in dropdown
			return this.educationalBackground.slice( 0, 1 );
		},

	},
	data() {
		return {
			educationalBackground: '',
			chosenCountry: '',
			chosenNationality: '',
			commentary: false,
			popupData: null,
			isSubmitting: false,
			submitStatus: '',
			countries: countries,
			CPR: 'P',
			ForNavn: '',
			EfterNavn: '',
			cprField: '',
			gender: '',
			DateOfBirth: '',
			otherHigherEducation: '',
			eksamenstypeField: '',
			EksamensAr: '',
            nameOfEducation: '',
            nameOfHigherEducation: '',
            previousEducation: false,
			files: [],
			locationChoices: [],
			studyLocation: '',
		};
	},
	watch: {
		qdPopup() {
			this.popupData = this.qdPopup !== null ? this.qdPopup.data : null;
			this.commentary = false;
			this.educationalBackground = '';
			this.chosenCountry = '';
			this.submitStatus = '';
			this.locationChoices = this.popupData && 'signup_location_choices' in this.popupData ? this.popupData.signup_location_choices : [];
			this.studyLocation = '';
		},
	},
	methods: {
		addCommentary() {
			this.commentary = true;
		},
		validateBeforeSubmit( event ) {
			this.$validator.validateAll().then( () => {
				this.submit( event.target );
			});
		},
		submit( el ) {
			this.isSubmitting = true;

			submitForm( el )
				.then( () => {
					this.submitStatus = 'success';
					this.isSubmitting = false;

					// TagManager
					trackFormSubmit( 'EducationSignup' );
				})
				.catch( () => {
					this.submitStatus = 'error';
					this.isSubmitting = false;
				});
		},
		isValidStudyLocation( location ) {
			return this.locationChoices.indexOf( location ) !== -1;
		},
	},
};

/**
 * Posts form to API
 */
function submitForm( el ) {

	const formData = new FormData( el );

	return $.ajax({
		url: '/wp-json/qd/forms/v1/easv_edu_signup',
		type: 'POST',
		data: formData,
		cache: false,
		contentType: false,
		processData: false,
	});
}


/**
 * Check that value equals on or more of the given valuesToCheck
 * 
 * @param {any} value 
 * @param {any|any[]} valuesToCheck 
 * @returns {boolean}
 */
function oneOf( value, valuesToCheck ) {
	const check = Array.isArray( valuesToCheck ) ? valuesToCheck : [ valuesToCheck ];
	return check.indexOf( value ) !== -1;
}



// WEBPACK FOOTER //
// ./assets/_js/components/education-signup/education-signup.js